import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { DashboardData, PolicySummary } from '../models';

/**
 * Home/Dashboard Service for IH API
 * Handles dashboard data and policy summaries
 * Always calls real backend API
 */
@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseHttpService {
  private readonly HOME_ENDPOINT = 'home';

  /**
   * Get complete dashboard data including policies, products, and notifications
   * GET /api/ih/home/dashboard/{phone}
   */
  getDashboard(phone: string): Observable<DashboardData> {
    return this.get<DashboardData>(`${this.HOME_ENDPOINT}/dashboard/${phone}`);
  }

  /**
   * Get user policies
   * GET /api/ih/home/policies/{phone}
   */
  getUserPolicies(phone: string): Observable<PolicySummary[]> {
    return this.get<PolicySummary[]>(`${this.HOME_ENDPOINT}/policies/${phone}`);
  }

  /**
   * Get Image cover
   * GET /api/ih/home/ih-cover
   */
  getImgCover(): Observable<string> {
    return this.get<string>(`${this.HOME_ENDPOINT}/ih-cover`);
  }
  
}
